<template>
  <button 
    class="close-button" 
    @click="handleClose"
    :aria-label="ariaLabel"
    type="button"
  >
    <svg class="close-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  close: []
}>()

defineProps<{
  ariaLabel?: string
}>()

const handleClose = () => {
  emit('close')
}
</script>

<style scoped>
.close-button {
  background: transparent;
  border: none;
  color: var(--text-secondary, #9ca3af);
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s ease, opacity 0.15s ease;
  flex-shrink: 0;
  position: relative;
  z-index: 10001;
  pointer-events: auto;
}

.close-button:hover {
  color: var(--text-color, #ffffff);
  opacity: 1;
}

.close-button:focus {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
  border-radius: 0.25rem;
}

.close-button:active {
  opacity: 0.7;
}

.close-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: currentColor;
  stroke-width: 2;
}

/* Mobile-friendly touch target - ensure minimum 44px for accessibility */
@media (max-width: 768px) {
  .close-button {
    width: 2.75rem;
    height: 2.75rem;
    min-width: 2.75rem;
    min-height: 2.75rem;
  }
  
  .close-icon {
    width: 1.75rem;
    height: 1.75rem;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .close-button {
    color: var(--text-color, #ffffff);
  }
  
  .close-icon {
    stroke-width: 2.5;
  }
}

@media (hover: hover) {
  .close-button:hover {
    color: var(--text-color, #ffffff);
    opacity: 1;
  }
}
</style>

